import { LucideIconData } from 'lucide-angular';

export const PoolCaC8: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M9 7 V17' }],
  ['path', { d: 'M9 13 H15' }],
  ['path', { d: 'M15 13 V17' }],
];
